
import { Business, Portfolio, BusinessRole, BusinessStatus } from './types/businessTypes';
import { industries, getIndustryById, getIndustryVerticals, getServiceDataKey } from './industries';

export {
  type Business,
  type Portfolio,
  type BusinessRole,
  type BusinessStatus,
  industries,
  getIndustryById,
  getIndustryVerticals,
  getServiceDataKey
};

// Utility functions to replace mock data functions
export const getAllIndustries = (): string[] => {
  return industries.map(industry => industry.name);
};

export const getAllPortfolioTitles = (): string[] => {
  // This is a placeholder - actual implementation will use context
  return [];
};
